module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-14-7edd396eb92ca0079f1679ea6a3dfdaa.jpg";